import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { ProfileService } from '../../services/profile/profile.service';
import { PROFILE_TYPE } from '../../constants/config';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers: [UserService, ProfileService]
})
export class SidebarComponent implements OnInit {
  isIndividual: boolean = !!(JSON.parse(localStorage.getItem('CURRENT_USER')).profile_type == 1);
  progressPercentage: number = 0;
  profileProgress: any = [
    {
      name: 'Create your profile',
      value: 'Create your profile',
      isComplete: true
    },
    {
      name: 'image',
      value: `Add a <a href="javascript:void(0)">profile photo</a>`,
      isComplete: false,
      hideCondition: PROFILE_TYPE.company,
      link: '/profile'
    },
    {
      name: 'logo',
      value: `Add a <a href="javascript:void(0)">company logo</a>`,
      isComplete: false,
      hideCondition: PROFILE_TYPE.user,
      link: '/profile'
    },
    {
      name: 'about_me',
      value: `Add an <a href="javascript:void(0)">"about me"</a>`,
      isComplete: false,
      hideCondition: PROFILE_TYPE.company,
      link: '/profile'
    }, {
      name: 'about_us',
      value: `Add an <a href="javascript:void(0)">"about us"</a>`,
      isComplete: false,
      hideCondition: PROFILE_TYPE.user,
      link: '/profile'
    }, {
      name: 'purchase_county',
      value: `Select your <a href="javascript:void(0)">service areas</a>`,
      isComplete: false,
      link: '/service-areas'
    },
    {
      name: 'review',
      value: `Get your first <a href="javascript:void(0)">review</a>`,
      isComplete: false,
      link: '/request-review'
    }
    // {
    //   name: 'purchase_package',
    //   value: `Become a <a href="javascript:void(0)">Preferred Partner</a>`,
    //   isComplete: false,
    //   link: '/package'
    // }
  ];
  profile_type: any;
  constructor(private _user: UserService,
    private router: Router,
    private _common: CommonService,
    private _profile: ProfileService,
    private title: Title) {
    this._common.onChangeProfile.subscribe(res => {
      this.checkIsIndividual();
      this.getProfileProgress();
    })
  }

  ngOnInit() {
    // this.checkIsIndividual();
    // this.getProfileProgress();
  }

  getProfileProgress() {
    this._profile.getProfileProgress().then((data) => {
      for (let key in data) {
        for (let i = 0; i < this.profileProgress.length; i++) {
          if (this.profileProgress[i].name == key) {
            this.profileProgress[i].isComplete = data[key];
          }
        }
      };
      this.checkProgress(data);
      // for (let i = 0; i < this.profileProgress.length; i++) {
      //   if (this.profileProgress[i].isComplete) {
      //     this.progressPercentage++;
      //   }
      // };
      // console.log(this.progressPercentage);

    }).catch((err) => {
      console.log(err);
    })
  }
  checkIsIndividual() {
    if (localStorage.getItem('CURRENT_USER')) {
      this.profile_type = JSON.parse(localStorage.getItem('CURRENT_USER')).profile_type;
    }
  }
  checkProgress(obj) {
    let count = 0;
    for (let key in obj) {
      if (obj[key]) {
        count++;
      }
    }
    this.progressPercentage = count + 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts